module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="calendacc-footer">\r\n\r\n  <!-- <span class="calendacc-footer-title-jours cw-texteImportant">'+
((__t=(i18n.t('calendacc.jours')))==null?'':__t)+
'</span> -->\r\n  \r\n  <div class="ui-jours-ferie typeFe container">\r\n    <div class="cw-texteAllege">'+
((__t=(i18n.t('calendacc.jourFe')))==null?'':__t)+
'</div>\r\n  </div>\r\n  \r\n\r\n  <div class="ui-phx-jours-exceptionnel typeEx container">\r\n    <div class="cw-texteAllege">'+
((__t=(i18n.t('calendacc.jourEx')))==null?'':__t)+
'</div>\r\n  </div>\r\n  \r\n\r\n  <span class="calendacc-footer-title-zones cw-texteImportant">'+
((__t=(i18n.t('calendacc.zones')))==null?'':__t)+
'</span>\r\n\r\n  <div class="zoneSc">\r\n    \r\n  </div>\r\n</div>\r\n';
}
return __p;
};
